<template>
  <div class="card-content">
    <div class="mt-s">
      <div class="mb-5 w-full">
        <fieldset>
          <div class="form-group">
            <input
              v-model="searchQuery"
              type="search"
              class="form-control form-search"
              placeholder="Type to find what you are looking for"
              aria-controls="datatables"
              autofocus
            />
          </div>
        </fieldset>
      </div>

      <div>
        <el-table
          class="table-striped"
          :data="queriedData"
          :default-sort="defaultSort"
          border
        >
          <el-table-column
            label="Description"
            prop="description"
            sortable
            :sort-orders="['ascending', 'descending']"
            min-width="450"
          >
            <template #default="scope">
              <div class="flex">
                <div class="mr-3">
                  <a @click.prevent="handleItemClick(scope.row)">
                    {{ scope.row.description }}
                  </a>
                </div>
                <Icon v-show="scope.row.files_count" :type="'attachment'" />
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="Issued"
            prop="issued_at"
            sortable
            :sort-orders="['ascending', 'descending']"
            min-width="150"
          >
            <template #default="scope">
              {{ formatDate(scope.row.issued_at) }}
            </template>
          </el-table-column>

          <el-table-column
            label="Expiration"
            prop="expiry_at"
            sortable
            :sort-orders="['ascending', 'descending']"
            min-width="150"
          >
            <template #default="scope">
              <div class="flex">
                <div class="mr-3">
                  {{ formatDate(scope.row.expiry_at) }}
                </div>
                <Icon :type="scope.row.status" />
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- <div class="flex justify-between items-center">
        <div>
          <p class="category">
            Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
          </p>
        </div>

        <p-pagination
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="pagination.total"
        />

        <div>
          <el-select
            v-model="pagination.perPage"
            class="select-default"
            placeholder="Per page"
          >
            <el-option
              v-for="item in pagination.perPageOptions"
              :key="item"
              class="select-default"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { Table, TableColumn } from "element-ui";
import tableConfig from "@providers/table";
import HelperDate from "@helpers/dates";
import Icon from "@components/UIComponents/TopicIcon/Icon";
//import PPagination from "@components/UIComponents/Pagination.vue";
import Vue from "vue";

Vue.use(Table);
Vue.use(TableColumn);

export default {
  components: {
    //PPagination,
    Icon,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["eventShow"],
  data() {
    return {
      ...tableConfig.data,
      propsToSearch: ["description", "expiry_at", "issued_at"],
      defaultSort: { prop: "description", order: "ascending" },
    };
  },
  computed: {
    ...mapGetters("loadingStore", { isLoading: "loading" }),
    tableData() {
      return this.parseData(this.data);
    },
    ...tableConfig.computed,
  },
  async mounted() {},
  methods: {
    formatDate(date) {
      return HelperDate.formatDate(date);
    },
    handleItemClick(event) {
      this.$emit("eventShow", event);
    },
    parseData(list){
      return list.map((item)=>{
        item.expiry_at = item.expiry_at ? item.expiry_at : '';
        return item;
      });
    }
  },
};
</script>

<style lang="scss"></style>
